import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "SettingsRowWrapper",
  componentId: "sc-18wzo2c-0"
})(["margin-bottom:20px;"]);